module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Bold.woff2?ec64ea577b0349e055ad6646c1d8797a";